import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const AccountNotificationPreferenceTable = React.lazy(() => import('../components/NotificationPreferences/AccountNotificationPreferenceTable'));

function AccountNotificationPreferencesView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <AccountNotificationPreferenceTable {...props} />
    </Suspense>
  );
}

export default AccountNotificationPreferencesView;
